import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import { login, getUserInfo, getUserList, removeUser, editUser } from '@/api/users';
import store from '@/store';
import { getToken, setToken, removeToken } from '@/utils/cookies';
import { Role, IUser, IUserEdit } from '@/api/types';

@Module({ dynamic: true, store, name: 'account' })
class AccountModule extends VuexModule {
  public userList: IUser[] = [];

  @Mutation
  private setUserList(userList: IUser[]) {
    this.userList = userList;
  }

  @Action({ rawError: true })
  public async fetchUserList() {
    const { data } = await getUserList();
    this.setUserList(data);
  }

  @Action({ rawError: true })
  public async removeUser(_id: string) {
    await removeUser(_id);
    this.setUserList(this.userList.filter((i) => i._id !== _id));
  }

  @Action({ rawError: true })
  public async editUser(user: IUserEdit) {
    await editUser(user);
  }
}

export const accountModule = getModule(AccountModule);
